import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  background: ${props => props.theme.cardBackground};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  padding: 0;
  width: auto;
  max-width: 90vw;
  min-width: 420px;
  min-height: 220px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    max-width: 100vw;
    min-width: 100vw;
    width: 100vw;
    max-height: 90vh;
    height: 90vh;
    margin: 0;
    padding: 0;
    top: 5vh;
    left: 0;
    right: 0;
    bottom: auto;
    transform: none;
  }
`;

const ModalHeader = styled.div`
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid ${props => props.theme.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => props.theme.background};
  flex-shrink: 0;
`;

const ModalTitle = styled.h2`
  margin: 0;
  color: ${props => props.theme.text};
  font-size: 1.25rem;
  font-weight: 600;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.textMuted};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  line-height: 1;

  &:hover {
    background: ${props => props.theme.borderLight};
    color: ${props => props.theme.text};
  }
`;

const ModalContent = styled.div`
  padding: 2rem;
  overflow-y: auto;
  flex: 1;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 2rem;
  }
`;

// Set app element for react-modal accessibility
if (typeof document !== 'undefined') {
  try {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      Modal.setAppElement(rootElement);
    } else {
      // Fallback for test environments where #root may not exist
      Modal.setAppElement(document.body);
    }
  } catch (error) {
    // In case react-modal throws (e.g., no DOM in SSR), fallback gracefully.
    console.warn('react-modal setAppElement failed:', error.message);
  }
}

const CustomModal = ({ isOpen, onClose, title, children, size = 'default' }) => {
  // Determine width based on size prop
  const getWidth = () => {
    switch(size) {
      case 'xlarge': return '1400px';
      case 'large': return '900px';
      case 'medium': return '40%';
      default: return 'auto';
    }
  };

  const getMaxWidth = () => {
    switch(size) {
      case 'xlarge': return '95vw';
      case 'large': return '90vw';
      case 'medium': return '40%';
      default: return '90vw';
    }
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000
        },
        content: {
          width: getWidth(),
          maxWidth: getMaxWidth()
        }
      }}
    >
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
        <CloseButton onClick={onClose}>×</CloseButton>
      </ModalHeader>
      <ModalContent>
        {children}
      </ModalContent>
    </StyledModal>
  );
};

export default CustomModal;